import store from '@/store';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import {PaginationRequestType} from "@/entity/common/pagination.types";

import {
    ServiceNomenclatureCreateRequestType,
    ServiceCreateRequestType
} from '@/form/serviceCreate/serviceCreate.types';

import {ResponseDataType} from "@/form/form.types";
import { prepareFormData } from '@/store/utils/formDataHelper'
import {
    IServicesNomenclatures,
    IServicesNomenclaturesListItem,
    IServicesNomenclaturesTree
} from "@/entity/servicesNomenclature/services.nomenclature.types";
@Module({
    namespaced: true,
    name: 'servicesNomenclature',
    store,
    dynamic: true
})

class ServiceNomenclatureModule extends VuexModule implements IStoreReady {
    services: IServicesNomenclatures | null = null
    tree: IServicesNomenclaturesTree[] = []
    service:  IServicesNomenclaturesListItem | null = null
    serviceLoaded   = false
    servicesLoaded  = false
    treeLoaded  = false
    ready = false

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ services: IServicesNomenclatures;  servicesLoaded: boolean }> {

        let servicesLoaded = false;
        const services = await store.$repository.servicesNomenclatures.fetchAll(prepareFormData(data));
        if(services){
            servicesLoaded = true;
        }
        return { services, servicesLoaded}
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ service: IServicesNomenclaturesListItem  ; serviceLoaded: boolean }> {
        let serviceLoaded = false;
        const service = await store.$repository.servicesNomenclatures.fetchData(data);
        if (service) {
            serviceLoaded = true;
        }
        return { service, serviceLoaded};
    }

    @MutationAction
    async getTree(data?: {name: string}): Promise<{ tree: IServicesNomenclaturesTree[];  treeLoaded: boolean }> {

        let treeLoaded = false;
        const tree = await store.$repository.servicesNomenclatures.getTree(data);
        if(tree){
            treeLoaded = true;
        }
        return { tree, treeLoaded}
    }

    @Action({rawError: true})
    async create(data: ServiceNomenclatureCreateRequestType): Promise<ResponseDataType> {
        return  await store.$repository.servicesNomenclatures.create(data);
    }

    @Action({rawError: true})
    async update(data: ServiceCreateRequestType): Promise<ResponseDataType> {
        return await store.$repository.servicesNomenclatures.update(data);
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        return  await store.$repository.servicesNomenclatures.delete(data);
    }
    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
}

export const ServiceNomenclatureStore = getModule(ServiceNomenclatureModule);